import { QueryFactory } from "../../../../Common";
export const QGetTournamentWinners = QueryFactory("GetTournamentWinners");
//# sourceMappingURL=QGetTournamentWinners.js.map